import MercadoPagoReturn from './MercadoPagoReturn';
export default MercadoPagoReturn;
